var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { "container container-xs": _vm.hideSocials } }, [
    _c("div", { staticClass: "row d-lg-flex d-md-flex d-sm-block d-block" }, [
      _c(
        "div",
        {
          staticClass: "col-sm-12 col-12 pr-md-5",
          class: { "col-lg-6 col-md-6 border-right": !_vm.hideSocials },
        },
        [
          _c("Username", {
            attrs: {
              title: _vm.$t("label_email"),
              errorMsg: _vm.errorMsgs.username,
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.login()
              },
              input: function ($event) {
                return _vm.updateUsername($event)
              },
            },
            model: {
              value: _vm.username,
              callback: function ($$v) {
                _vm.username = $$v
              },
              expression: "username",
            },
          }),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center",
              },
              [
                _c("label", { attrs: { for: "passwordLogin" } }, [
                  _vm._v(_vm._s(_vm.$t("label_password"))),
                ]),
                _c(
                  "router-link",
                  {
                    staticClass: "link p-0",
                    attrs: { to: { name: "reset-password" } },
                  },
                  [_vm._v(_vm._s(_vm.$t("btn_reset_password")))]
                ),
              ],
              1
            ),
            _c("span", { staticClass: "invalid-feedback" }, [
              _vm._v(" " + _vm._s(_vm.errorMsgs.password) + " "),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password",
                },
              ],
              staticClass: "w-100",
              class: { "has-error": _vm.errorMsgs.password },
              attrs: { type: "password" },
              domProps: { value: _vm.password },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.login()
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.password = $event.target.value
                },
              },
            }),
          ]),
          _c("div", { staticClass: "col-md-6 p-0 col-sm-12" }, [
            _c(
              "div",
              { staticClass: "action-button text-center" },
              [
                _c(
                  "van-button",
                  {
                    staticClass: "main-btn",
                    attrs: {
                      dusk: "login-button",
                      block: "",
                      loading: _vm.loading,
                      square: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.login()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("btn_login")))]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "mt-4 d-flex justify-content-between cont-nou" },
            [
              _c(
                "span",
                [
                  _vm._v(_vm._s(_vm.$t("login_component_no_account")) + " "),
                  _c(
                    "router-link",
                    {
                      staticClass: "link",
                      attrs: { to: { name: "new-account" } },
                    },
                    [_vm._v(_vm._s(_vm.$t("new_account_title")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "or grey d-flex align-items-end d-sm-block d-md-none",
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("or")))])]
          ),
        ],
        1
      ),
      !_vm.hideSocials
        ? _c(
            "div",
            {
              staticClass: "col-lg-6 col-md-6 col-sm-12 col-12 pl-md-5 pt-md-4",
            },
            [
              _c(
                "button",
                {
                  staticClass: "google-login-btn",
                  attrs: { loading: _vm.loadingGoogle },
                  on: {
                    click: function ($event) {
                      return _vm.loginGoogle()
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.$t("continue_with")) + " Google "),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "facebook-login-btn",
                  attrs: { loading: _vm.loadingFacebook },
                  on: {
                    click: function ($event) {
                      return _vm.loginFacebook()
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      " " + _vm._s(_vm.$t("continue_with")) + " Facebook "
                    ),
                  ]),
                ]
              ),
              ["ios", "desktop"].includes(_vm.os())
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "apple-login-btn",
                        attrs: { loading: _vm.loadingApple },
                        on: {
                          click: function ($event) {
                            return _vm.loginApple()
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            " " + _vm._s(_vm.$t("continue_with")) + " Apple "
                          ),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }